import Breakdown from './Breakdown';

export interface IChartGroup {
  name: string;
  charts: string[];
  breakdowns: Breakdown[];
}

class ChartGroup {
  public readonly name: string;
  public readonly charts: string[];
  public readonly breakdowns: Breakdown[];

  constructor({ name, charts, breakdowns }: { name: string; charts: string[]; breakdowns: Breakdown[] }) {
    this.name = name;
    this.charts = charts;
    this.breakdowns = breakdowns;
  }

  public toJSON = () => ({
    name: this.name,
    charts: this.charts,
    breakdowns: this.breakdowns,
  });

  public static fromJSON = (json: IChartGroup): ChartGroup => {
    const { name, charts, breakdowns } = Object.assign({}, json);

    if (typeof name !== 'string') throw new Error('.name must be a string');
    if (!Array.isArray(charts)) throw new Error('.charts must be an array');
    if (!Array.isArray(breakdowns)) throw new Error('.breakdowns must be an array');

    return new ChartGroup({
      name,
      charts,
      breakdowns,
    });
  };
}

export default ChartGroup;
